/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import FormDuuf from 'components/Form'
import ParseContent from '../shared/ParseContent'
import { FormCSS } from '../../styles/FormStyle'

const Section = styled.section`
  background-color: ${(props) => props.theme.color.main};

  @media (min-width: 992px) {
    padding-top: 72px;
    padding-bottom: 70px;
  }

  @media (max-width: 991.98px) {
    padding-block: 3rem;
  }
`

const Box = styled.div`
  position: relative;
  max-width: 981px;
  margin-inline: auto;
  background-color: ${(props) => props.theme.color.greyAlt};

  /* Notched bottom-right corner, cut out of the dark section behind it. */
  &::after {
    position: absolute;
    content: '';
    right: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-top: 70px solid transparent;
    border-right: 70px solid ${(props) => props.theme.color.main};
    z-index: 2;
  }

  @media (min-width: 992px) {
    padding: 83px 100px 60px;
  }

  @media (max-width: 991.98px) {
    padding: 2rem 1.5rem 3rem;

    &::after {
      border-top-width: 35px;
      border-right-width: 35px;
    }
  }
`

const Title = styled.h2`
  color: ${(props) => props.theme.color.text.main};
  font-weight: 600;
  margin-bottom: 1.5rem;

  @media (min-width: 992px) {
    font-size: 32px;
    line-height: 46px;
  }

  @media (max-width: 991.98px) {
    font-size: 26px;
    line-height: 32px;
  }
`

const Description = styled.div`
  & p {
    font-size: 18px;
    line-height: 25px;
  }
`

const StyledFormDuuf = styled(FormDuuf)`
  ${FormCSS}

  .form-duuf-label-mandatory {
    display: none !important;
  }

  .form-duuf-label {
    color: ${(props) => props.theme.color.text.main};
    font-style: italic;
    font-size: 20px;
    margin-bottom: 0.25rem !important;
  }

  .form-duuf-input,
  .form-duuf-textarea {
    background-color: #fff;
    border: 1px solid ${(props) => props.theme.color.grey};
  }

  .form-duuf-input {
    width: 100%;
    max-width: 380px;
  }

  .form-duuf-textarea {
    width: 100%;
    max-width: 380px;
  }

  .form-duuf-submit {
    float: unset;
    margin-right: 0;
    margin-top: 1.5rem;

    & > button {
      padding: 12px 24px;
      font-size: 24px;
      clip-path: polygon(
        0 0,
        100% 0,
        100% calc(100% - 14px),
        calc(100% - 14px) 100%,
        0 100%
      );

      &::after {
        background-image: none;
        width: 0;
        height: 0;
        margin-left: 25px;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 12px solid currentColor;
      }
    }
  }
`

function ContactLanding({ title, description }) {
  return (
    <Section id="contact">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Box>
              <div className="row">
                <div className="col-lg-6 mb-5 mb-lg-0">
                  <StyledFormDuuf
                    id={4}
                    generate
                    privacyUrlPlacement="privacyverklaring"
                    privacyUrl="/privacyverklaring"
                  />
                </div>

                <div className="col-lg-6 pl-lg-5">
                  {title && <Title>{title}</Title>}
                  {description && (
                    <Description>
                      <ParseContent content={description} />
                    </Description>
                  )}
                </div>
              </div>
            </Box>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default ContactLanding
